import { render, staticRenderFns } from "./CDLQI.vue?vue&type=template&id=37fcb841&"
import script from "./CDLQI.vue?vue&type=script&lang=js&"
export * from "./CDLQI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports